module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACHSURBVEhL7ZRLCoAwDAV7O8X7n0A9R2sCg1kEofZDCzqQRV/aCWTR8DMPMcZN6kyVqENqRWtIeHCnGnHtaA16iWMxaLyH/HEA7RtiB+0JB+SCZuCAVqA1yJuB1iDvvyKODto3xA7aEw7IBc2AAd0/O/1itcGdYtQhtaD1cO/1qnhWveLPEcIF8ZzJbpw0eZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bureau/light/24.png
// module id = 1906
// module chunks = 2